export default "__VITE_ASSET__DFeSOn8X__"